import React,{useEffect,useState,useMemo} from 'react';
import { v4 as uuid } from 'uuid';
import { Formik, Form } from 'formik';
import FormikControl from '../../../../../components/FormikControls/FormikControl';
import { AddEvalFace } from '../../../Interfaces/interfaces';
import DyButton from '../../../../../components/GlobalComponents/DyButton/DyButton';
// import { currentStateOptions, nextStateOptions } from '../../../StataicData';
import { useAddCheckinBAUMeeting } from '../../../Hooks/index';
// import ListSelect from '../../../../../components/GlobalComponents/ListSelect/ListSelect';
import { useSelector } from 'react-redux';
import { useGetBAUHistoryCheckinByIdQuery } from '../../../Hooks/index';
import {Tooltip} from '@mui/material';
import {CircularProgress} from '@mui/material';
import { Grid,Box,Typography,Divider} from '@mui/material';
import { ObjectiveSelectedFace,krSelectedFace } from '../../../Interfaces/interfaces';
import DyDataGrid from '../../../../../components/GlobalComponents/DyDataGrid2/DyDataGrid';
// import DyLinearProgress from '../../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
import Assessor from '../../Assessor/Assessor';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import IconButton from '@mui/material/IconButton';
// import sad from '../../../../../Asset/Svgs/Emojys/sad 1.svg';
// import meh from '../../../../../Asset/Svgs/Emojys/neutral 2.svg';
// import smile from '../../../../../Asset/Svgs/Emojys/smil.png';
// import MoreVert from '@mui/icons-material/MoreVert';
import { ErrorMessage } from 'formik';
import DYToastMessage from "../../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import "../../../../CompanyManagment/Forms/RegisterTenant/Error.css"
// import IconButton from '@mui/material';
// import { useSelector } from 'react-redux';
// import {ReactComponent as Smile} from '../../../../../Asset/Svgs/Emojys/smile 1.svg';

interface progValueFace{
  assessmentRate:null|number,
  score:null|number
}

// setShowToastMessage={setShowToastMessage}
// setAddEvalAsyncData={setAddEvalAsyncData}

export const CreateBAUeval = ({cancelo,objectiveManiInfo,krMainInfo,objectiveId, kresultId,afterAddKr,onsucces,setAddEvalAsyncData}:any) => {
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);
    const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
    const teamId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
    const periodId: any = useSelector((state: any) => state.meetings.priodId);
    const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    const[progressFormValues,setProgressFormValues]=useState<progValueFace>({assessmentRate:0,score:0});
    const[keyResultMeetingHistoryDtos,setKeyResultMeetingHistoryDtos]=useState<any[]>([]);
    const[assessmentHistory,setAssessmentHistory]=useState<any[]>([]);
    const[formIds,setFormIds]=useState<any>({meetingId:meetingId,periodId:periodId,keyResultId:null});
    const[tensileScore,setTensileScore]=useState<string|null>('');
    const addKrStatusData:any=useSelector((state:any)=>state.meetings.addKrStatusData);
    const [showToastMessage, setShowToastMessage] = useState<any>(false);
    const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
    const formatValue = (value: number | string) => {
      const numValue = Number(value); // تبدیل به عدد برای بررسی منفی بودن
      return numValue < 0 ? `${Math.abs(numValue)}-` : `${numValue}`;
  };
    const {data:historyData,isLoading:historyDataLoading}:any=useGetBAUHistoryCheckinByIdQuery(formIds)
    const { mutate: addCheck, isSuccess,isLoading:AddChekinLoading,data:addCheckingData } = useAddCheckinBAUMeeting();

    let{name,id,responsibleName,upperLimit,startValue,lowerLimit,source,description}:any|null=objectiveManiInfo;

    const evaluationData: any = {
      newValue: '',
      problems: '',
      nextState: '',
      meetingId: meetingId,
      teamId: teamId,
      periodId: periodId,
      tenantId: profileTenantId,
      keyResultId: kresultId,
      objectiveId: objectiveId,
      currentState: '',
      description: description,
      source:source,
      closedKeyResult: false
    }
   const[selectedInitialValue,setSelectedInitialValue]=useState<any>(evaluationData)

  const initialSubmitForm: any = (data: any): any => {
    let totalData={...data,tensileScore:String(tensileScore)}
    console.log(totalData)
    addCheck(totalData)
  }

  const initialCancel = (): void => {
    cancelo(false)
  }

  useEffect(() => {
  if (historyData) {
    let{assessmentRate,score,bauMeetingHistoryDtos,assessmentHistory}=historyData;
    let progData={assessmentRate:assessmentRate,score:score};
    setKeyResultMeetingHistoryDtos(bauMeetingHistoryDtos?.map((item:any)=>({id:uuid(),...item})));
    setAssessmentHistory(assessmentHistory?.map((item:any)=>({id:uuid(),...item})))
    setProgressFormValues(progData)
  }
  }, [historyData])

  useEffect(() => {
    let{description,name,id,responsibleName,upperLimit,startValue,
      lowerLimit,currentValue,problems,source}:any|null=objectiveManiInfo;
    let initValues={
      newValue:currentValue,
      name:name,
      problems:problems,
      upperLimit:upperLimit,
      startValue:startValue,
      lowerLimit:lowerLimit,
      responsibleName:responsibleName,
      currentValue:currentValue,
      description:description,
      source:source
    }
    setFormIds((prev:any)=>({...prev,keyResultId:id}));
    setSelectedInitialValue((prev:any)=>({...prev,...initValues}))
   
  }, [objectiveManiInfo])
  

const KRHColumns: any = useMemo(()=>
  [
    {
      field: "rowid",
      headerName: "ردیف",
      width: 35,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    }
    ,
    { 
      field: 'meetingDate',
      headerName: 'تاریخ جلسه',
      sortable:false,
      headerAlign:'center',
      align:'center',
      width: 100,
    }
    ,
    { 
      field: 'newValue',
      headerName: 'مقدار اعلام شده',
      align:'center',
      sortable:false,
      headerAlign:'center',
      width: 150,
      renderCell:({value}:any)=>{
        if (value!==null) {
            return <Box>
            {
            value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
            {value}
            </Tooltip>:
            <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
            }
            </Box>
            }
        else {
             return null
        }
        }
    }
          ,
  { field: 'meetingNumber',
       align:'center',
       headerName: 'شماره جلسه',
       headerAlign:'center',
       sortable:false,
       wrap:'wrap',
        minWidth: 130,
        fontsize:'12px !important',
  }
  ,
  // {
  //   field: 'source',
  //   headerName: 'منبع',
  //   align: 'center',
  //   headerAlign: 'center',
  //   sortable: false,
  //   minWidth: 110,
  //   // fontsize:'12px',

  //   renderCell:({value}:any)=>{
  //     return <Box>
  //      {
  //       value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
  //       {value}
  //     </Tooltip>:
  //     <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
  //      }
  //     </Box>
  //   }
  // },

  // revenue
        { field: 'startValue',
        headerName: 'شروع',
        sortable:false,
        headerAlign:'center',
        align:'center',
         width: 110 ,
         renderCell:({value}:any)=>{
          return <Box>
           {
            value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
            {value}
          </Tooltip>:
          <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
           }
          </Box>
        }
        },
        { field: 'lowerLimit',
          headerName: 'حد پایین',
          sortable:false,
          headerAlign:'center',
          align:'center',
           width: 110 ,
           renderCell:({value}:any)=>{
            return <Box>
             {
              value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
              {value}
            </Tooltip>:
            <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
             }
            </Box>
          }
          },
          { field: 'upperLimit',
            headerName: 'حد بالا',
            sortable:false,
            headerAlign:'center',
            align:'center',
             width: 110 ,
             renderCell:({value}:any)=>{
              return <Box>
               {
                value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
                {value}
              </Tooltip>:
              <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
               }
              </Box>
            }
            },
        // {
        //   field: 'revenue',
        //   headerName: 'عملکرد',
        //   align: 'center',
        //   headerAlign: 'center',
        //   sortable: false,
        //   minWidth: 110,
        //   renderCell: ({ value }: any) => {
        //     // console.log(value)
        //   if (value) {
        //     return <Box>
        //     {
        //       value.length > 40 ? <Tooltip sx={{ fontSize: '1.5rem !important' }} title={value}>
        //         {value}
        //       </Tooltip> :
        //         <Typography sx={{ fontSize: '12px' }} >{value}</Typography>
        //     }
        //   </Box>
        //   }
        //   }
        // }
       // ,
        // { field: 'score',
        //   headerName: 'امتیاز',
        //   align:'center',
        //   sortable:false,
        //   headerAlign:'center',
        //   width: 80 ,
        //   renderCell:(par:any)=>{
        //    let score:string=par?.row?.score;
        //    // console.log(score);
        //    if ( typeof score==='string' &&  score.includes('%')) {
        //      let pureNum=score.slice(0,score.length-1);
        //      let intVal=+pureNum;
        //      let color='';
        //     let fColor=''
        //     switch (true) {
        //      case intVal>=70:
        //        color='#D5F7D4';
        //        fColor='#125610'
        //        break;
        //        case intVal<70 &&  intVal>30:
        //        color='#FFF8D0';
        //        fColor='#6B6440'
        //        break
        //      default:
        //        color='#FFEEE5'
        //        fColor='#993600'
        //        break;
        //     }
        //      return <Box m={3} 
        //      borderRadius={2} 
        //      width={'100%'} 
        //      display={'flex'} 
        //      justifyContent={'center'} 
        //      alignItems={'center'} 
        //      height={'65%'}   
        //      bgcolor={color}
        //      my={1}
        //       >
        //        <Typography px={8} fontSize={'0.8rem'} color={fColor} fontWeight={400} >
        //        {intVal}
        //        </Typography>
        //      </Box>
        //    }
        //    else{
        //      return<Box>
        //        <Typography>{score}</Typography>
        //      </Box>
        //    }
        //   }
        
        //  }
        {
          field: 'description',
          headerName: 'توضیحات',
          align: 'center',
          headerAlign: 'center',
          sortable: false,
          minWidth: 110,
          // fontsize:'12px',
      
          renderCell:({value}:any)=>{
            return <Box>
             {
              value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
              {value}
            </Tooltip>:
            <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
             }
            </Box>
          }
        },
      
    ],[]);


    useEffect(() => {
      // setAddEvalAsyncData,setShowToastMessage
    // console.log(addCheckingData)
    // setShowToastMessage(true)
    // setAddEvalAsyncData(addCheckingData?.data)

    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
          // setShowEditKeyResult(false)
          // setAddKrState(editKrData?.data)
          // editKrSuccess()
          // setShowToastMessage(true)
         setShowToastMessage(true)
         setShowToastMessageResult(addCheckingData?.data.metaData.message);
         setAddEvalAsyncData(addCheckingData?.data)
         onsucces(false)
      } else {
        //console.log('locall')
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
          // setEditAsyncData(editKrData?.data)
      }
  }
    }, [addCheckingData])

    if (historyDataLoading) {
       return <Grid container  >
      <Box width={'100%'} py={5} textAlign={'center'} >
       <CircularProgress color='primary'   />
      </Box>
     </Grid>
    }

  return (
    <Grid container  >
    <Grid item xs={12}  >
    <Box width={'100%'} 
    minHeight={'110px'} 
    borderRadius={2} 
    sx={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',alignItems:'center'}}
    >
    <Box sx={{width:'40%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
    <Divider />
    <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >شاخص:</Typography> <Typography variant='caption'>{name}</Typography></Box>
    <Divider />
    <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مسئول:</Typography> <Typography variant='caption'>{responsibleName}</Typography>  </Box>
    <Divider />
    <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >تاریخ جلسه:</Typography> <Typography variant='caption'>{meetSelectedDate}</Typography>  </Box>
 
    </Box>
    <Box  sx={{width:'35%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
    <Divider />
    <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مقدار شروع:</Typography> <Typography variant='caption'  >{startValue}</Typography>  </Box>
    <Divider />
    <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >حد پایین:</Typography> <Typography variant='caption'  >{lowerLimit}</Typography>  </Box>
    <Divider />
    <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >حد بالا :</Typography> <Typography variant='caption'  >{upperLimit}</Typography>  </Box>
    <Divider />
    </Box>
    </Box>
    </Grid>

    <Grid  item xs={12} >
    {
      historyDataLoading && <Grid container  >
       <Box width={'100%'} py={5} textAlign={'center'} >
        <CircularProgress color='primary'   />
       </Box>
      </Grid>
    }
    {
       historyData && <Grid  container >
       <Grid item xs={12} mx={'auto'} sx={{bgcolor:'#F9F9F9'}}  >
       <Formik
              // validationSchema={pointSystemsL==="مرحله ای"?straddKrSchema:intaddKrSchema}
               enableReinitialize
               initialValues={selectedInitialValue || evaluationData  }
               onSubmit={(data: AddEvalFace) => {
                 initialSubmitForm(data)
               }}
               validate={(data)=>{
                 console.log(data)
               }}
             >
               {
                 ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }:any) =>
                   <Form>
                     {
                       true && 
                       <Grid container columnSpacing={1} sx={{bgcolor:'#F9F9F9',mx:'auto',borderRadius:3}}   >
                      {/* <Grid item xs={8.5}  >
                      <div className='error'>
                      <ErrorMessage name="newValue" />
                      </div>
                         <FormikControl
                           control='textField'
                          //  type='text'
                           label='مقدار جدید'
                           name='newValue'
                          //  fullWidth
                           value={values?.newValue || ''}
                          //  description={'hi'}
                          //  helperText='kjkj'
                          //  errors={errors}
                          //  type={pointSystemsL==="مرحله ای"?'text':'number'}
                         />
                       </Grid> */}
                      <Grid item xs={8.5}>
                            <div className='error'>
                                <ErrorMessage name="newValue" />
                            </div>
                            <FormikControl
                                control='textField'
                                label='مقدار جدید'
                                name='newValue'
                                value={values?.newValue ? formatValue(values.newValue) : ''}
                            />
                        </Grid>
                         {/* {
                           pointSystemsL==='مرحله ای'?
                           <Grid item xs={2}  > 
                         <ErrorMessage name="tensileScore" />
                         <FormikControl
                           fullWidth
                           control='textField'
                          //  type='text'
                           name='tensileScore'
                         label='امتیاز' 
                         size='small'
                        //  name='tensileScore'
                         value={tensileScore || ''}
                        //  error={tensileScore===''}
                        //  type={pointSystemsL==="مرحله ای"?'text':'number'}
                          onChange={({target}:any)=>{
                            let{value}=target;
                            setTensileScore(value)
                          }}
                           />
                       </Grid>:''
                         }
    */}
                       <Grid item xs={12}  md={8.5}  >
                         <FormikControl
                           control='textField'
                           type='text'
                           label='منبع'
                           name='source'
                           fullWidth
                           value={values?.source || ''}
                         />
                       </Grid>
                       
                       <Grid item xs={12} md={3} >
                       <Box width={'100%'} textAlign={'center'} py={1} >
                       <Assessor 
                        setSelectedInitialValue={setSelectedInitialValue}
                        optionList={assessmentHistory} 
                        />
                       </Box>
                       </Grid>
   
                       <Grid item xs={12} md={10}  >
                         <FormikControl
                           control='textField'
                           type='text'
                           label='توضیحات'
                           name='description'
                           fullWidth
                           value={values?.description || ''}
                           placeholder={'توضیحات (اختیاری)  0/300'}
                         />
                       </Grid>

                       <Grid item xs={12}   >
                          <DyDataGrid
                          columns={KRHColumns || []}
                          data={keyResultMeetingHistoryDtos||[]}
                          setRowSelectedData={()=>{}}
                          hideFooter={true}
                          setSelectionModel={()=>{}}
                          selectionModel={''}
                          additionalToolbar={false}
                          drName={'hisTable'}
                          initialOnRowClick={()=>{}}
                          withoutOptions={true}
                          />
                      </Grid>
   
                       <Grid item xs={12}  mt={0.5} >
                         <Box   columnGap={2} display={'flex'} flexDirection={'row-reverse'}  >
                           <Box >
                             <DyButton
                               caption={'ذخیره'}
                               color={'#00387C'}
                               onClick={() => { }}
                               variant={'contained'}
                               bgColor={'#00387C'}
                               type={'submit'}
                             />
                           </Box>
   
                           <Box>
                             <DyButton
                               caption={'انصراف'}
                               // color={'#00387C'}
                               // onClick={loginHandler}
                               disbled={false}
                               variant={'outlined'}
                               onClick={initialCancel}
                             />
                           </Box>
                         </Box>
                       </Grid>
                     </Grid>
                     }
                   </Form>
               }
             </Formik>
          </Grid>
        </Grid>
    }
    </Grid>
    {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={showToastMessageResult}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
    </Grid>
  )
}
